import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { FormData } from '@/shared/model/form.model';
import KeywordsCMSModel, { Keywords } from '@/visa-application/models/KeywordsCMSModel';
import _ from 'lodash';
import DirectusService from '@/core/directus/directus.service';
import PassbackAddressCMSModel from '@/visa-application/models/PassbackAddressCMSModel';

@Component
export default class ModifyAddress extends Vue {
  @Prop() public forms: FormData[];
  @Prop() public currentForm: FormData;
  @Prop() public modifyAddress: Function;
  @Prop() public cmsData: PassbackAddressCMSModel;
  public currentLanguage = this.$store.getters.currentLanguage;
  private keywords: Partial<Keywords> = {};
  public formAddressToUpdata: FormData[] = [];
  public showCopyAddressPopup = false;
  public copyForm: FormData;

  @Inject('directusService') private directusService: () => DirectusService;

  @Watch('$store.getters.keywords', { immediate: true })
  public onKeywordsChanged(keywords: Keywords): void {
    this.keywords = keywords;
  }

  public mounted(): void {
    if (this.currentForm) {
      this.$nextTick(() => {
        document.getElementById('form_' + this.currentForm.f_id).scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      });
    }
  }

  public toggleDropdown(currentForm: FormData, index: number) {
    if (!currentForm.dropdownStatus) {
      this.forms.forEach(form => {
        if (form.f_id === currentForm.f_id) {
          form.dropdownStatus = true;
        } else if (!form.fixedDropdownStatusAsTrue) {
          form.dropdownStatus = false;
        }
      });
    } else if (!this.forms[index].fixedDropdownStatusAsTrue) {
      this.forms[index].dropdownStatus = false;
    }
    this.$forceUpdate();
  }

  public onFormsChanged(inputRef, inputValue, index): void {
    if (_.trim(inputValue)) {
      this.$refs[inputRef][0].setAttribute('class', 'hidden');
      if (this.forms[index].house_number && this.forms[index].street && this.forms[index].city && this.forms[index].postcode) {
        this.forms[index].fixedDropdownStatusAsTrue = false;
      }
    } else {
      this.showErrorMsg(inputRef, index);
    }
    this.$forceUpdate();
  }

  public showErrorMsg(inputRef, index): void {
    this.$refs[inputRef][0].setAttribute('class', 'error');
    this.$refs[inputRef][0].innerText = _.get(this.keywords, 'empty_error_message', 'Input can not be empty.');
    this.forms[index].fixedDropdownStatusAsTrue = true;
    this.forms[index].dropdownStatus = true;
    this.$forceUpdate();
  }

  public CopyAddressPopup(formIndex: number): void {
    this.validateForms();
    if (this.forms[formIndex].fixedDropdownStatusAsTrue) {
      return;
    }
    this.copyForm = this.forms[formIndex];
    this.showCopyAddressPopup = true;
  }

  public copyAddress(): void {
    const passbackAdress = [];
    passbackAdress[0] = this.copyForm.house_number;
    passbackAdress[1] = this.copyForm.street;
    passbackAdress[2] = this.copyForm.city;
    passbackAdress[3] = this.copyForm.postcode;

    for (const form of this.forms) {
      [form.house_number, form.street, form.city, form.postcode] = [...passbackAdress];
      form.dropdownStatus = true;
    }
    this.showCopyAddressPopup = false;
    this.validateForms();
    this.$forceUpdate();
  }

  public validateForms(): void {
    this.forms.forEach((form, index) => {
      if (form.house_number.trim().length === 0) {
        this.showErrorMsg('house_number_' + form.f_id, index);
      } else {
        this.onFormsChanged('house_number_' + form.f_id, form.house_number.trim(), index);
      }
      if (form.street.trim().length === 0) {
        this.showErrorMsg('street_' + form.f_id, index);
      } else {
        this.onFormsChanged('street_' + form.f_id, form.street.trim(), index);
      }
      if (form.city.trim().length === 0) {
        this.showErrorMsg('city_' + form.f_id, index);
      } else {
        this.onFormsChanged('city_' + form.f_id, form.city.trim(), index);
      }
      if (form.postcode.trim().length === 0) {
        this.showErrorMsg('postcode_' + form.f_id, index);
      } else {
        this.onFormsChanged('postcode_' + form.f_id, form.postcode.trim(), index);
      }
    });
  }

  public sanitizeForm(form: FormData) {
    const copy = { ...form };

    Object.entries(form).forEach(([key, value]) => {
      if (typeof value === 'string') {
        copy[key] = _.escape(value);
      }
    });

    return copy;
  }

  public saveAllAddress(): void {
    this.validateForms();
    const errorElements = document.getElementsByClassName('error');
    if (errorElements.length > 0) {
      this.$nextTick(() => {
        errorElements[0].scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      });
    } else {
      this.formAddressToUpdata = [];
      this.forms.forEach((form, index) => {
        let addressContent = '';
        addressContent += form.house_number.trim() + '\r\n';
        addressContent += form.street.trim() + '\r\n';
        addressContent += form.city.trim() + '\r\n';
        addressContent += form.postcode.trim();

        if (addressContent !== form.fi_passback_address) {
          const sanitizedForm = this.sanitizeForm(form);
          this.formAddressToUpdata.push(sanitizedForm);
          this.formAddressToUpdata[this.formAddressToUpdata.length - 1].fi_passback_address = addressContent;
        }
      });
      this.modifyAddress(this.formAddressToUpdata);
    }
  }
}
